var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeMaintenance.website_alert_text)?_c('div',{staticClass:"banner"},[_c('i',{staticClass:"fa fa-warning"}),_vm._v(" "+_vm._s(_vm._f("localizedMaintenanceText")(_vm.activeMaintenance,_vm.$i18n.locale))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }